// Sign-in and password screens (EMR#4990). Kept apart from LOCAL_MESSAGES so release and dev do
// not conflict on them; the keys are new, so EMR's remote locale cannot override them.
export const AUTH_MESSAGES = {
  en: {
    'Professional portal': 'Professional portal',
    'Employer portal': 'Employer portal',
    'Person portal': 'Person portal',
    'Other portal:': 'Other portal:',
    'Help with signing in': 'Help with signing in',
    'Privacy statement': 'Privacy statement',
    'Email address': 'Email address',
    'Forgot password?': 'Forgot password?',
    'Sign in': 'Sign in',
    'Next, we will ask for the code from your authenticator app.':
      'Next, we will ask for the code from your authenticator app.',
    'Absence, medical examinations, PMO and sustainable employability in one platform.':
      'Absence, medical examinations, PMO and sustainable employability in one platform.',
    'For occupational physicians, case managers and the whole occupational health team.':
      'For occupational physicians, case managers and the whole occupational health team.',
    'Use your professional account.': 'Use your professional account.',
    'The email address or password is incorrect. Check your details and try again.':
      'The email address or password is incorrect. Check your details and try again.',
    'Enter code': 'Enter code',
    'Open your authenticator app and enter the 6-digit code for inCTRL.':
      'Open your authenticator app and enter the 6-digit code for inCTRL.',
    'Authenticator code': 'Authenticator code',
    'Digit {n} of {total}': 'Digit {n} of {total}',
    Confirm: 'Confirm',
    'Back to sign in': 'Back to sign in',
    'No longer have access to your authenticator app, for example because of a new phone? Contact {organisation} to link your app again.':
      'No longer have access to your authenticator app, for example because of a new phone? Contact {organisation} to link your app again.',
    'your occupational health service': 'your occupational health service',
    'Almost done': 'Almost done',
    'With the authenticator app you protect your data, even if someone else knows your password.':
      'With the authenticator app you protect your data, even if someone else knows your password.',
    'Link authenticator app': 'Link authenticator app',
    'We ask for a code from this app every time you sign in.':
      'We ask for a code from this app every time you sign in.',
    'Install an authenticator app on your phone, for example Google Authenticator or Microsoft Authenticator.':
      'Install an authenticator app on your phone, for example Google Authenticator or Microsoft Authenticator.',
    'Scan this QR code with the app.': 'Scan this QR code with the app.',
    'QR code for your authenticator app': 'QR code for your authenticator app',
    "Can't scan? Enter this key:": "Can't scan? Enter this key:",
    'Enter the 6-digit code from the app.': 'Enter the 6-digit code from the app.',
    'Link and sign in': 'Link and sign in',
    'Forgot password': 'Forgot password',
    'Enter the email address you sign in with. You will receive a link to set a new password.':
      'Enter the email address you sign in with. You will receive a link to set a new password.',
    'Send link': 'Send link',
    'Check your email': 'Check your email',
    'If an account belongs to {email}, you will receive an email with a link within a few minutes. The link is valid for {duration}.':
      'If an account belongs to {email}, you will receive an email with a link within a few minutes. The link is valid for {duration}.',
    '60 minutes': '60 minutes',
    'Tip:': 'Tip:',
    'No email? Also check your junk mail and whether the email address is correct.':
      'No email? Also check your junk mail and whether the email address is correct.',
    'You can resend in {time}': 'You can resend in {time}',
    'Send again': 'Send again',
    'Choose your password': 'Choose your password',
    'New password': 'New password',
    'Repeat password': 'Repeat password',
    'Save password': 'Save password',
    'Password requirements': 'Password requirements',
    'At least 12 characters': 'At least 12 characters',
    'Upper and lower case letters': 'Upper and lower case letters',
    'At least one number': 'At least one number',
    'At least one symbol, such as ! or #': 'At least one symbol, such as ! or #',
    'requirement met': 'met',
    'requirement not met yet': 'not met yet',
    'The password does not meet all requirements yet.':
      'The password does not meet all requirements yet.',
    'The password can be at most 50 characters.': 'The password can be at most 50 characters.',
    'The passwords do not match.': 'The passwords do not match.',
    'Your password is set': 'Your password is set',
    'You can now sign in with your new password.': 'You can now sign in with your new password.',
    'Go to sign in': 'Go to sign in',
    'This link has expired or was already used': 'This link has expired or was already used',
    'Ask for a new link and we will email it to you.':
      'Ask for a new link and we will email it to you.',
    'Send me a new link': 'Send me a new link',
    'Checking your link…': 'Checking your link…',
    'Account activated': 'Account activated',
    'Your email address is confirmed. Set a password to sign in.':
      'Your email address is confirmed. Set a password to sign in.',
    'Set password': 'Set password',
    'This link is invalid or has expired': 'This link is invalid or has expired',
    'Ask your administrator for a new invitation, or sign in if your account is already active.':
      'Ask your administrator for a new invitation, or sign in if your account is already active.',
    'Enter a valid email address.': 'Enter a valid email address.',
    'Enter your password.': 'Enter your password.',
    'Something went wrong. Please try again.': 'Something went wrong. Please try again.',
  },
  nl: {
    'Professional portal': 'Professionalportaal',
    'Employer portal': 'Werkgeversportaal',
    'Person portal': 'Persoonsportaal',
    'Other portal:': 'Ander portaal:',
    'Help with signing in': 'Hulp bij inloggen',
    'Privacy statement': 'Privacyverklaring',
    'Email address': 'E-mailadres',
    'Forgot password?': 'Wachtwoord vergeten?',
    'Sign in': 'Inloggen',
    'Next, we will ask for the code from your authenticator app.':
      'Daarna vragen we om de code uit uw authenticator-app.',
    'Absence, medical examinations, PMO and sustainable employability in one platform.':
      'Verzuim, keuringen, PMO en duurzame inzetbaarheid in één platform.',
    'For occupational physicians, case managers and the whole occupational health team.':
      'Voor bedrijfsartsen, casemanagers en het hele arboteam.',
    'Use your professional account.': 'Gebruik uw professionele account.',
    'The email address or password is incorrect. Check your details and try again.':
      'Het e-mailadres of wachtwoord klopt niet. Controleer uw gegevens en probeer het opnieuw.',
    'Enter code': 'Code invoeren',
    'Open your authenticator app and enter the 6-digit code for inCTRL.':
      'Open uw authenticator-app en voer de code van 6 cijfers voor inCTRL in.',
    'Authenticator code': 'Authenticatorcode',
    'Digit {n} of {total}': 'Cijfer {n} van {total}',
    Confirm: 'Bevestigen',
    'Back to sign in': 'Terug naar inloggen',
    'No longer have access to your authenticator app, for example because of a new phone? Contact {organisation} to link your app again.':
      'Geen toegang meer tot uw authenticator-app, bijvoorbeeld door een nieuwe telefoon? Neem contact op met {organisation} om uw app opnieuw te koppelen.',
    'your occupational health service': 'uw arbodienst',
    'Almost done': 'Bijna klaar',
    'With the authenticator app you protect your data, even if someone else knows your password.':
      'Met de authenticator-app beschermt u uw gegevens, ook als iemand anders uw wachtwoord kent.',
    'Link authenticator app': 'Authenticator-app koppelen',
    'We ask for a code from this app every time you sign in.':
      'Bij elke aanmelding vragen we om een code uit deze app.',
    'Install an authenticator app on your phone, for example Google Authenticator or Microsoft Authenticator.':
      'Installeer een authenticator-app op uw telefoon, bijvoorbeeld Google Authenticator of Microsoft Authenticator.',
    'Scan this QR code with the app.': 'Scan deze QR-code met de app.',
    'QR code for your authenticator app': 'QR-code voor uw authenticator-app',
    "Can't scan? Enter this key:": 'Lukt scannen niet? Voer deze sleutel in:',
    'Enter the 6-digit code from the app.': 'Voer de code van 6 cijfers uit de app in.',
    'Link and sign in': 'Koppelen en inloggen',
    'Forgot password': 'Wachtwoord vergeten',
    'Enter the email address you sign in with. You will receive a link to set a new password.':
      'Vul het e-mailadres in waarmee u inlogt. U ontvangt een link om een nieuw wachtwoord in te stellen.',
    'Send link': 'Link versturen',
    'Check your email': 'Controleer uw e-mail',
    'If an account belongs to {email}, you will receive an email with a link within a few minutes. The link is valid for {duration}.':
      'Als er een account hoort bij {email}, ontvangt u binnen enkele minuten een e-mail met een link. De link is {duration} geldig.',
    '60 minutes': '60 minuten',
    'Tip:': 'Tip:',
    'No email? Also check your junk mail and whether the email address is correct.':
      'Geen e-mail ontvangen? Kijk ook bij ongewenste e-mail en controleer of het e-mailadres klopt.',
    'You can resend in {time}': 'Opnieuw versturen kan over {time}',
    'Send again': 'Opnieuw versturen',
    'Choose your password': 'Kies uw wachtwoord',
    'New password': 'Nieuw wachtwoord',
    'Repeat password': 'Herhaal wachtwoord',
    'Save password': 'Wachtwoord opslaan',
    'Password requirements': 'Wachtwoordeisen',
    'At least 12 characters': 'Minimaal 12 tekens',
    'Upper and lower case letters': 'Hoofdletters en kleine letters',
    'At least one number': 'Minimaal één cijfer',
    'At least one symbol, such as ! or #': 'Minimaal één symbool, zoals ! of #',
    'requirement met': 'voldaan',
    'requirement not met yet': 'nog niet voldaan',
    'The password does not meet all requirements yet.':
      'Het wachtwoord voldoet nog niet aan alle eisen.',
    'The password can be at most 50 characters.': 'Het wachtwoord mag maximaal 50 tekens zijn.',
    'The passwords do not match.': 'De wachtwoorden komen niet overeen.',
    'Your password is set': 'Uw wachtwoord is ingesteld',
    'You can now sign in with your new password.': 'U kunt nu inloggen met uw nieuwe wachtwoord.',
    'Go to sign in': 'Naar inloggen',
    'This link has expired or was already used': 'Deze link is verlopen of al gebruikt',
    'Ask for a new link and we will email it to you.':
      'Vraag een nieuwe link aan, dan mailen we die naar u.',
    'Send me a new link': 'Stuur mij een nieuwe link',
    'Checking your link…': 'Uw link wordt gecontroleerd…',
    'Account activated': 'Account geactiveerd',
    'Your email address is confirmed. Set a password to sign in.':
      'Uw e-mailadres is bevestigd. Stel een wachtwoord in om in te loggen.',
    'Set password': 'Wachtwoord instellen',
    'This link is invalid or has expired': 'Deze link is ongeldig of verlopen',
    'Ask your administrator for a new invitation, or sign in if your account is already active.':
      'Vraag een nieuwe uitnodiging aan bij uw beheerder, of log in als uw account al actief is.',
    'Enter a valid email address.': 'Vul een geldig e-mailadres in.',
    'Enter your password.': 'Vul uw wachtwoord in.',
    'Something went wrong. Please try again.': 'Er ging iets mis. Probeer het opnieuw.',
  },
} satisfies Record<'en' | 'nl', Record<string, string>>
